import { useNotification } from "components/Notification/useAddNotification";

export const useLoginNotification = () => {
  const { addNotification } = useNotification();

  const showSuccessNotification = () =>
    addNotification({
      title: notificationMessage.notificationTitle,
      description: notificationMessage.notificationSuccessMessage,
      type: "success",
    });

  const showErrorNotification = (description?: string) =>
    addNotification({
      title: notificationMessage.notificationTitle,
      description:
        description ?? notificationMessage.notificationErrorMessage,
      type: "error",
    });

  return { showSuccessNotification, showErrorNotification };
};

const notificationMessage = {
  notificationTitle: "Logowanie",
  notificationErrorMessage: "Nie udało się zalogować.",
  notificationSuccessMessage: "Pomyślnie zalogowano.",
};
